<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-col :span="10" class="item">
                                    <el-form-item label="商品数量" required>
                                        <el-input-number v-model="number"
                                                         style="width:100%" :min="1" ></el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-col :span="18" class="item">
                                    <el-form-item label="选择预约时间" required>
<!--                                        <el-date-picker-->
<!--                                            v-model="planTime"-->
<!--                                            type="datetime"-->
<!--                                            :clearable="false"-->
<!--                                            placeholder="请选择预约时间"-->
<!--                                            :default-value="new Date()"-->
<!--                                            :picker-options="pickerOptions0"-->
<!--                                            value-format="yyyy-MM-dd HH:mm"-->
<!--                                            format="yyyy-MM-dd HH:mm"-->
<!--                                            style="width:100%">-->
<!--                                        </el-date-picker>-->
                                      <el-date-picker
                                          v-model="planTime"
                                          type="datetime"
                                          style="width:100%;"
                                          value-format="yyyy-MM-dd HH:mm"
                                          placeholder="选择预约时间">
                                      </el-date-picker>

                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'CartEdit',
        data() {
            return {
                loading: false,

                number:1,
                planTime:'',
                beforeCartGoodsCode:'',

                row:'',
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },  
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],

                }

            }
        },

        methods: {

            init(row){
                console.log(row);

                this.number=row.number
                this.planTime=timefilters(row.planTime)
                this.beforeCartGoodsCode=row.beforeCartGoodsCode
            },

            closeSelf() {
                this.$emit("closeCartEdit");
            },

            confirm(){

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/BeforeCartChange",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                      beforeCartGoodsCode:this.beforeCartGoodsCode,
                      number:this.number,
                      planTime:timefilters(this.planTime),
                    }
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {

                            this.$emit("closeCartEdit");
                            this.$emit("getGoods");

                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )


            },


        }
    }


</script>
